import React from 'react'
import ReactPaginate from "react-paginate";
import { useEffect, useState } from "react";
import Axios from "../../../services/AxiosInstance";
//import { Navigate, useNavigate } from 'react-router-dom';
import Notification from "../../Notification";
import { Link, } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

 export default function IssueList() {

    //const [searchData, setsearchData] = useState('');
    const [items, setItems] = useState([]);
   
    const [totalPages, setTotalPage] = useState(0);
    const [pageCount, setpageCount] = useState(0);
    const [loading, setLoading] = useState(false)
    //const [isChecked, setisChecked] = useState(false);
    // const [sorting, setSorting] = useState([]);
    const [notify, setNotify] = useState({ isOpen: false, messsage: '', type: '' })
    const [perPage, setPerpage] = useState(process.env.REACT_APP_PER_PAGE)
    const [viewMoreData, setviewMoreData] = useState([]);
    const navigate = useNavigate();
    


    useEffect(() => {
        
        const IssueList = async () => {
            const res = await Axios.get(
   `/api/issues?pageNo=1&perPage=${perPage}`
)
            //console.log("hello",res.data.data.data);
            setItems(res.data.data.data);
            setTotalPage(res.data.data.totalPage)
            setpageCount(Math.ceil(res.data.data.totalPage));
            // setLoading(false)
            // setItems(posts);
        };
        IssueList();
    }, [perPage]);

   

    
    const fetchgetIssueListList = async (currentPage) => {
        const res = await Axios.get(
   `/api/issues?pageNo=${currentPage}&perPage=${perPage}`
)
        // console.log(res.data.data.data)
        await setItems(res.data.data.data);
        return items;
    };

    const handlePageClick = async (items) => {
        console.log(items.selected);

        let currentPage = items.selected + 1;
        //const searchBy =  document.getElementById("search_by_id").value;
        // if(searchData !== "" && searchBy !== ""){
        //     await searchHandle (currentPage)
        // }else{

        //     await fetchgetissueListingList(currentPage);
        // }
        await fetchgetIssueListList(currentPage);


    };
    // const viewMore = async (business_id) => {
    //     alert('hii');
    //     const status = business_id;
    //     console.log('hii',status);
    //     const res = await Axios.get(`api/business/issue-listing?business_id=${business_id}`)
    //     setviewMoreData(res.data.data.data[0]);
    //     console.log(res.data.data.data[0]);
    // }

    // const searchHandle = async (currentPage) => {

    //     const searchBy =  document.getElementById("search_by_id").value;
    //     if (searchData !== "" && searchBy !== "") {
    //         alert("hello")
    //         const res = await Axios.post(`api/business/utilize-messages-list?pageNo=${currentPage}&perPage=${perPage}&searchData=${searchData}&search_by=${searchBy}`)
    //       console.log('hii',res)
    //        if(res.data.data[0].data.length>0){
    //         setItems(res.data.data[0].data)
    //         setTotalPage(res.data.data[0].totalPage)
    //         setpageCount(Math.ceil(res.data.data[0].totalPage));
    //        }
    //        if(res.data.data[0].data.length<=0){
    //         setItems([])
    //         setTotalPage(res.data.data[0].totalPage)
    //         setpageCount(Math.ceil(res.data.data[0].totalPage))
    //        }
    //     } else {
    //         setNotify({
    //             isOpen: true,
    //             messsage: `Search By and Search Value Should Not Be Blank!`,
    //             type: 'error',
    //         })
    //     }
    // }

    const handleNavigate = (issue_id)=>{

let selectedIssue =
items.find(
(item)=>
item.issue_id === issue_id
);

if(!selectedIssue)
return;

navigate(
'/IssueCommunication',
{

state:{

busineName:
selectedIssue.business_name,

problemTitle:
selectedIssue.problem_title,

problemDescription:
selectedIssue.problem_desc,

issueID:
selectedIssue.issue_id,

businessId:
selectedIssue.business_id,

currentTicketStatus:
selectedIssue.status

}

}

);

};

    return (
        <>
            <div className="content-page">
                <div className="content">
                    {/* <!-- Start Content--> */}
                    <div className="container-fluid">

                        {/* <!-- start page title --> */}
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box">

                                    <center><h4 className="page-title">Issue Listing</h4></center>
                                </div>
                            </div>
                        </div>
                        {/* <!-- end page title -->  */}

                        <div className="row">
                            <div className="col-12">
                                <div className="card-box table-responsive">
                                    {
                                        notify.isOpen ?
                                            <Notification
                                                notify={notify}
                                                setNotify={setNotify} />
                                            : ""
                                    }
                                    {/* <span><b>Search By:-</b></span>
                                             <select name="search_by" id="search_by_id">
                                            <option value="">Select</option>
                                            <option value="business_name">Business Name</option>
                                            <option value="package_name">Package Name</option>
                                           
                                            
                                        </select>&nbsp;&nbsp;&nbsp;
                                        <input type="" className='search-business-list' placeholder='Search...'
                                         onChange={(e) => setsearchData(e.target.value)}
                                        />
                                        <button type="Search" className="find-list"onClick={searchHandle}>Search</button> */}


                                  <table
  className="table table-hover table-bordered"
  style={{
    width: "100%",
    background: "#fff",
    borderRadius: "12px",
    overflow: "hidden",
    minWidth: "1600px"
  }}
>

  <thead
    style={{
      background: "#f8f9fa",
      textAlign: "center"
    }}
  >

    <tr>

      <th>S.No</th>

      <th>Business ID</th>

      <th>Issue ID</th>

      <th>Business Name</th>

      <th>Category</th>

      <th>Problem Title</th>

      <th>Problem Desc</th>

      <th>Added By</th>

      <th>Added Date</th>

      <th>Date Time</th>

      <th>Screenshot</th>

      <th>Status</th>

      <th>Action</th>

    </tr>

  </thead>

  <tbody>

    {
      items && items.length > 0 ? (

        items.map((issueList, index) => (

          <tr
            key={index}
            style={{
              verticalAlign: "middle",
              textAlign: "center"
            }}
          >

            <td>
              {index + 1}
            </td>

            <td>
              {issueList.business_id || "-"}
            </td>

            <td>
              {issueList.issue_id || "-"}
            </td>

            <td>
              {issueList.business_name || "-"}
            </td>

            <td>

  <span
    style={{
      background: "#7367f0",

      color: "#fff",

      padding: "6px 14px",

      borderRadius: "20px",

      fontSize: "12px",

      fontWeight: "600",

      display: "inline-block",

      maxWidth: "160px",

      whiteSpace: "normal",

      wordBreak: "break-word",

      lineHeight: "18px",

      textTransform: "capitalize"
    }}
  >

    {issueList.category || "-"}

  </span>

</td>

            <td
              style={{
                maxWidth: "220px",
                whiteSpace: "normal",
                wordBreak: "break-word",
                fontWeight: "600"
              }}
            >
              {issueList.problem_title || "-"}
            </td>

            <td
              style={{
                maxWidth: "300px",
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "28px"
              }}
            >
              {issueList.problem_desc || "-"}
            </td>

            <td>
              {issueList.added_by || "-"}
            </td>

            <td>

              {
                issueList.added_date
                  ? new Date(
                      issueList.added_date
                    ).toLocaleDateString()
                  : "-"
              }

            </td>

            <td>

              {
                issueList.added_date
                  ? new Date(
                      issueList.added_date
                    ).toLocaleTimeString()
                  : "-"
              }

            </td>

            {/* SCREENSHOT COLUMN */}

            <td>

              {
                issueList.screenshot_path ? (

                  <button

                    type="button"

                    className="btn btn-info"

                    style={{
                      borderRadius: "8px",
                      padding: "6px 12px",
                      fontSize: "12px",
                      fontWeight: "600",
                      color: "#fff"
                    }}

                    onClick={() =>
                      window.open(
                        issueList.screenshot_path,
                        "_blank"
                      )
                    }

                  >

                    View Link

                  </button>

                ) : (

                  "-"

                )
              }

            </td>

          {/* STATUS */}

<td>

  <span
style={{

background:

issueList?.status
?.toLowerCase()

===

"resolved"

?

"#28c76f"

:

issueList?.status
?.toLowerCase()

===

"resolving"

?

"#ff9f43"

:

"#00cfe8",

color:"#fff",

padding:"6px 12px",

borderRadius:"20px",

fontSize:"12px",

fontWeight:"600",

textTransform:"capitalize",

minWidth:"90px",

display:"inline-block",

whiteSpace:"nowrap",

textAlign:"center"

}}

>

{issueList.status}

</span>
</td>

            {/* ACTION */}

            <td>

              <button
                type="button"
                className="btn btn-primary"

                style={{
                  borderRadius: "8px",
                  padding: "5px 10px",

                 fontSize: "13px",

                 minWidth: "80px",
                  fontWeight: "600"
                }}

                onClick={()=>{

handleNavigate(
issueList.issue_id
)

}}

              >

                View Reply

              </button>

            </td>

          </tr>

        ))

      ) : (

        <tr>

          <td
            colSpan="13"
            style={{
              textAlign: "center",
              fontWeight: "bold",
              padding: "30px"
            }}
          >

            No Issues Found

          </td>

        </tr>

      )
    }

  </tbody>

</table>

<div
  style={{
    marginTop: "25px"
  }}
>

  <ReactPaginate
    previousLabel={"Previous"}
    nextLabel={"Next"}
    breakLabel={"..."}
    pageCount={pageCount}
    marginPagesDisplayed={2}
    pageRangeDisplayed={3}
    onPageChange={handlePageClick}
    containerClassName={"pagination justify-content-center"}
    pageClassName={"page-item"}
    pageLinkClassName={"page-link"}
    previousClassName={"page-item"}
    previousLinkClassName={"page-link"}
    nextClassName={"page-item"}
    nextLinkClassName={"page-link"}
    breakClassName={"page-item"}
    breakLinkClassName={"page-link"}
    activeClassName={"active"}
  />

</div>

<div
  style={{
    marginTop: "20px",
    display: "flex",
    alignItems: "center",
    gap: "10px"
  }}
>

  <span>
    <b>Rows per page:-</b>
  </span>

 <select

value={perPage}

name="Rows per page"

onChange={
async (e)=>{

const value =
Number(
e.target.value
);

setPerpage(
value
);

await fetchgetIssueListList(
1
);

}
}

style={{

padding:"8px",

borderRadius:"6px",

border:"1px solid #ccc"

}}


>

    <option value="">
      Select Item Per Page
    </option>

    <option value="2">2</option>

    <option value="3">3</option>

    <option value="30">30</option>

    <option value="50">50</option>

    <option value="100">100</option>

    <option value="200">200</option>

  </select>

</div>  
</div>
                            </div>
                        </div>
                        {/* <!-- end row --> */}
                    </div>
                    {/* <!-- end container-fluid --> */}

                </div>
            </div>
        </>
    )
 }
